module.exports = __webpack_public_path__ + "img/143.efe73da8.jpg";